import { styled } from '../../styles';

export const SelectItemLabel = styled.span(() => ({
  flex: 1,
  textAlign: 'start' as any,
}));
